import { useParams } from 'react-router-dom'

interface ParamRemountProps {
  paramName: string
  Component: React.ComponentType<any>
}

/**
 * Forces component unmount+remount when the specified URL param changes.
 *
 * React Router v6 reuses component instances when only the param value changes
 * (e.g. /warehouse/stocks-management/5/materials → /warehouse/stocks-management/10/materials).
 * This wrapper uses `key` to force React to treat each param value as a new component instance,
 * ensuring hooks like `useEntityQuery({ refetchOnMount: 'always' })` fire correctly.
 */
export function ParamRemount({ paramName, Component }: ParamRemountProps) {
  const params = useParams()
  return <Component key={params[paramName] ?? 'no-param'} />
}
